import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a7ce706"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-endpoint-navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_endpoint_navigation = _resolveComponent("endpoint-navigation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.isPdfContent)
          ? (_openBlock(), _createBlock(_component_endpoint_navigation, {
              key: 0,
              modifier: _ctx.navigationModifier,
              "name-prev-path": _ctx.getNavigationEndpoints(-1),
              "name-next-path": _ctx.getNavigationEndpoints(1),
              "prev-path": _ctx.getNavigationEndpoints(-1),
              "next-path": _ctx.getNavigationEndpoints(1)
            }, null, 8, ["modifier", "name-prev-path", "name-next-path", "prev-path", "next-path"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}